export const apiDomain = "https://us-central1-train-5dc7f.cloudfunctions.net";

export const firebaseConfig = {
  apiKey: "AIzaSyBnWyECRoxG58iF7vOtz1jbkm2CHqIWvJo",
  authDomain: "train-5dc7f.firebaseapp.com",
  databaseURL: "https://train-5dc7f-default-rtdb.firebaseio.com",
  projectId: "train-5dc7f",
  storageBucket: "train-5dc7f.appspot.com",
  messagingSenderId: "749017692557",
  appId: "1:749017692557:web:1073c157056a411dcea5c4",
  measurementId: "G-Z5FQRN6254",
};
